import { render, staticRenderFns } from "./BundlePaymentDistribution.vue?vue&type=template&id=04f9eb68&scoped=true"
import script from "./BundlePaymentDistribution.vue?vue&type=script&lang=js"
export * from "./BundlePaymentDistribution.vue?vue&type=script&lang=js"
import style0 from "./BundlePaymentDistribution.vue?vue&type=style&index=0&id=04f9eb68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f9eb68",
  null
  
)

export default component.exports